/**
 * Class Name Utility
 *
 * Utility function for conditionally joining classNames together.
 * Commonly used with Tailwind CSS for dynamic class composition.
 *
 * @example
 * cn('base-class', isActive && 'active-class', className)
 * // => 'base-class active-class custom-class'
 */

type ClassValue = string | number | boolean | undefined | null | ClassValue[];

/**
 * Combines multiple class values into a single string.
 * Filters out falsy values and flattens arrays.
 *
 * @param inputs - Class values to combine
 * @returns Combined class string
 */
export function cn(...inputs: ClassValue[]): string {
  return inputs
    .flat()
    .filter((x): x is string | number => Boolean(x) && typeof x !== 'boolean')
    .map(String)
    .join(' ')
    .trim();
}

export default cn;
